export interface IBatchDetail {
    id: number;
    batchDate: string;
    uniqueIdentifier: string;
}

const newBatchDetail = (): IBatchDetail => ({
    id: 0,
    batchDate: "",
    uniqueIdentifier: ""
})

export const createBatchDetail = <T extends Partial<IBatchDetail>>(initialValues: T): IBatchDetail & T => {
    return Object.assign(newBatchDetail(), initialValues);
};